export default __webpack_public_path__ + "30f3d41e369ac150bdded5986ca4ff7c.png";